import { Church } from "lucide-react";
import { ChurchProfileForm } from "@/components/ChurchProfileForm";
import { useAuth } from "@/context/AuthContext";

export default function ChurchProfile() {
  const { checkAuth } = useAuth();
  return (
    <div className="p-6 lg:p-8 max-w-[900px] mx-auto">
      <h1 className="font-display text-3xl font-bold tracking-tight flex items-center gap-3"><Church className="h-7 w-7 text-amber-400" /> Church Profile</h1>
      <p className="text-gray-400 mt-1.5 text-sm">Keep your church's details up to date so we can reach you and show the right information to your viewers.</p>
      <div className="mt-8 bg-card border border-gray-800 rounded-2xl p-6">
        <ChurchProfileForm base="/profile" logoPath="/profile/logo" onSaved={() => checkAuth?.()} />
      </div>
    </div>
  );
}
